import { combineReducers } from "redux";
import loginReducer from './loginReducer'
import customers from './reducers'
import { autoDataReducer } from './preDataReducer'


export default combineReducers({
    loginReducer,
    customers,
    autoDataReducer
});